import React, { useState, useEffect, useRef, memo } from "react";
import "../../../assets/styles/local/loginscreen.css";
import {
  serverLogin,
  emailSend,
  EmailExistOrNot,
  VerifySignup,
  fetchTranslationData,
} from "../../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Row, Col, Modal } from "react-bootstrap";
import styled from "styled-components";
import logo from "../../../assets/images/Brand logo.jpg";
import smaliIcon from "../../../assets/icons/meh.svg";
import eyeIcon from "../../../assets/icons/eye.svg";
import noteyeIcon from "../../../assets/icons/Notshow.svg";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { fetchScreenTranslations } from "../../../utils/helpers/translations";

export function ServerLoginPage() {
  const history = useHistory();
  const dispatch = useDispatch();
  const emailStore = window.localStorage.getItem("email");
  const passwordStore = window.localStorage.getItem("password");
  const loginData = useSelector((state) => state.user.loginData);
  const EmailExistOrNotRes = useSelector((state) => state.user.EmailExistOrNot);
  const FetchCompanyDetails1 = useSelector(
    (state) => state.user.FetchCompanyDetails
  );
  const emailSenddata = useSelector((state) => state.user.forgotPassEmail);
  const [email, setEmail] = useState("");
  const [FetchCompanyThemRes, setFetchCompanyThemRes] = useState([]);
  const [emailsend, setEmailsend] = useState("");
  const [Password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [checkbox, setCheckbox] = useState(false);
  const [emailValid, setEmailValid] = useState(false);
  const [incpass, setIncPass] = useState(false);
  const [msgpop, setMsgpop] = useState("");
  const [msgalert, setMsgalert] = useState("");
  const initialRender = React.useRef(true);
  const [showPassword, setShowPassword] = useState(false);
  const [show, setShow] = useState(false);
  const [themeCompanyId, setThemeCompanyId] = useState(
    "28830f30-b321-4662-a576-f23451677734"
  );
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [emailErrsms, setEmailErrsms] = useState("");
  const [verifyEmail, setVerifyEmail] = useState("");
  const { userid } = useParams();
  const fetchTranslationDatas = useSelector(
    (state) => state.user.FetchTranslationList
  );
  const [fetchTransList, setFetchTransList] = useState({});
  const t = (key) => fetchTransList?.[key] || "";
  const [targetEnvironment, setTargetEnvironment] = useState("uat");
  const [isEnvError, setIsEnvError] = useState(false);
  React.useEffect(() => {
    fetchScreenTranslations("Login", {
      language: "English",
      companyid: themeCompanyId,
    }).then((res) => {
      setFetchTransList(res);
    });
  }, []);

  React.useEffect(() => {
    if (!initialRender.current) {
      if (loginData != null) {
        if (loginData.status == true) {
          if (
            loginData.data[0]?.companyinstance &&
            loginData.data[0]?.companyinstance.length > 0
          ) {
            const redirectData = {
              instanceId: loginData.data[0]?.companyinstance[0]?.instanceid,
              redirectUrl: loginData.data[0]?.companyinstance[0]?.redirecturl,
              companyId: loginData.data[0]?.companyinstance[0]?.companyid,
            };
            history.push({
              pathname: "/server-timeout",
              state: { data: redirectData },
            });
          } else {
            setIncPass(true);
            setMsgalert("Please contact admin support!");
          }
        } else {
          setMsgalert(loginData.message);
          setIncPass(true);
          setError(false);
        }
      }
      if (FetchCompanyDetails1 != null) {
        if (FetchCompanyDetails1.status == true) {
          setFetchCompanyThemRes(FetchCompanyDetails1.data);
          setThemeCompanyId(FetchCompanyDetails1.data[0]?.companyid);
        } else {
          <img src={logo} />;
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [loginData, FetchCompanyDetails1]);
  useEffect(() => {
    if (EmailExistOrNotRes != null) {
      if (EmailExistOrNotRes?.status == true) {
        setVerifyEmail("true");
        setEmailErrsms("");
      } else {
        setEmailErr(false);
        setEmailErrsms(EmailExistOrNotRes?.message);
      }
    }
  }, [EmailExistOrNotRes]);

  React.useEffect(() => {
    if (!initialRender.current) {
      if (emailSenddata != null) {
        if (emailSenddata.status == true) {
          setMsgpop(emailSenddata.message);
          setTimeout(() => {
            history.push("/");
            window.location.reload();
          }, 2000);
        } else {
          setMsgpop(emailSenddata.message);
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [emailSenddata]);
  const signupRenderer = useRef(true);
  useEffect(() => {
    if (userid && signupRenderer.current) {
      signupRenderer.current = false;
      dispatch(VerifySignup(userid));
      history.push("/");
    }
  }, [userid]);

  const validEmail = new RegExp(
    "^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$"
  );
  const [emailErr, setEmailErr] = useState(false);
  useEffect(() => {
    if (email === "") {
      setEmailErr(false);
      setEmailErrsms("");
    } else if (!validEmail.test(email)) {
      setEmailErr(true);
      setEmailErrsms("");
    } else if (email != "") {
      setEmailErr(false);
      dispatch(EmailExistOrNot(email));
    }
  }, [email]);

  const sendEmail = (e) => {
    if (emailsend == "") {
      e.preventDefault();
      setError(true);
    } else if (!validEmail.test(emailsend)) {
      e.preventDefault();
      setEmailValid(true);
    } else {
      dispatch(emailSend(emailsend));
      e.preventDefault();
    }
  };
  const handleSubmit = (e) => {
    if (email === "" || Password === "") {
      e.preventDefault();
      setError(true);
    } else if (email == "") {
      e.preventDefault();
      setError(true);
    } else if (Password == "") {
      e.preventDefault();
      setError(true);
    } else if (!targetEnvironment) {
      setIsEnvError(true);
    } else if (verifyEmail === "true") {
      if (checkbox == true) {
        window.localStorage.setItem("email", email);
        window.localStorage.setItem("password", Password);
      } else {
        window.localStorage.clear();
      }
      dispatch(serverLogin(email, Password, targetEnvironment));

      e.preventDefault();
    }
  };

  const backgroundIMG = {
    backgroundImage: `url(${FetchCompanyThemRes[0]?.backgroundimage})`,
  };
  const backgroundCOLOR = {
    backgroundColor: `${FetchCompanyThemRes[0]?.backgroundcolor}`,
  };
  const Wrapper2 = styled.div`
    .form-check-input:checked {
      background-color: ${FetchCompanyThemRes[0]?.primarycolor || ""};
    }
  `;

  return (
    <>
      <section
        style={
          FetchCompanyThemRes[0]?.backgroundcolor
            ? backgroundCOLOR
            : backgroundIMG
        }
      >
        <div
          className="login-main-container"
          style={{ "--text-color": `${FetchCompanyThemRes[0]?.textcolor}` }}
        >
          <Row className="w-100">
            <Col xs={12} sm={12} md={12} xl={7}>
              <div className="d-flex align-items-center justify-content-center">
                <img
                  className="company-logo"
                  src={FetchCompanyThemRes[0]?.companylogo}
                  alt="Company Logo"
                />
              </div>
            </Col>
            <Col xs={12} sm={12} md={12} xl={5}>
              <div className="d-flex align-items-center justify-content-center justify-content-lg-start">
                <label className="text-welcome">{t("Welcome")}</label>
              </div>
              <div className="d-flex align-items-center justify-content-center justify-content-lg-start">
                <div className="login-form">
                  <div
                    className={
                      !email && error
                        ? "text-start showerror"
                        : "text-start forminput"
                    }
                  >
                    <input
                      type="text"
                      id="userinput1"
                      value={email}
                      onChange={(e) => {
                        setError(false);
                        setEmail(e.target.value);
                        setIncPass(false);
                      }}
                      className="input-style2 input-width "
                      placeholder={t("email")}
                      style={{
                        borderBottom: "1px solid #A5A5A5",
                        color: `${FetchCompanyThemRes[0]?.textcolor}`,
                      }}
                    />
                    <div className="d-flex" style={{ marginTop: 5.67 }}>
                      {emailErr && (
                        <div className="warning">
                          <i class="me-1 bi bi-exclamation-circle"></i>
                          Incorrect email
                        </div>
                      )}
                      {emailErrsms && (
                        <div className="warning">
                          <i class="me-1 bi bi-exclamation-circle"></i>
                          {emailErrsms}
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    className="d-flex password-input"
                    style={{ borderBottom: "1px solid #A5A5A5" }}
                  >
                    <input
                      id="userinput2"
                      value={Password}
                      onChange={(e) => {
                        setError(false);
                        setPassword(e.target.value);
                        setIncPass(false);
                      }}
                      className="input-style2 input-width "
                      type={showPassword ? "text" : "password"}
                      placeholder={t("password")}
                      style={{
                        color: `${FetchCompanyThemRes[0]?.textcolor}`,
                      }}
                    />
                    {showPassword ? (
                      <img
                        src={eyeIcon}
                        style={{
                          color: "gray",
                          height: "14.5px",
                          width: "20.66px",
                        }}
                        className="bi-paperclip mt-1"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    ) : (
                      <img
                        src={noteyeIcon}
                        style={{
                          color: "gray",
                          height: "16.5px",
                          width: "20.66px",
                        }}
                        className="bi-paperclip mt-1"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    )}
                  </div>
                  <div
                    className="d-flex align-items-start justify-content-between"
                    style={{ marginTop: 6.67 }}
                  >
                    <div className="warning w-50">
                      {incpass && (
                        <div className="d-flex">
                          <i class="bi bi-exclamation-circle"></i>
                          <div className="ms-1">{msgalert}</div>
                        </div>
                      )}
                    </div>
                    <div className="form-check check-box w-50">
                      <Wrapper2>
                        <input
                          checked={checkbox}
                          type="checkbox"
                          onChange={() => setCheckbox(!checkbox)}
                          className="form-check-input checkbox1 "
                          id="exampleCheck1"
                          style={{ cursor: "pointer" }}
                        />
                      </Wrapper2>
                      <label className="keep-text">
                        {t("Keep me logged in")}
                      </label>
                    </div>
                  </div>
                  {/* <div className="my-4">
                                        <FormControl error={isEnvError}>
                                            <FormLabel id="rdo-environment">Environment</FormLabel>
                                            <RadioGroup
                                                row
                                                aria-labelledby="rdo-environment"
                                                name="rdoEnvironment"
                                                value={targetEnvironment}
                                                onChange={(e) => {
                                                    setIsEnvError(false)
                                                    setTargetEnvironment(e.target.value)
                                                }}>
                                                <FormControlLabel value="dev" control={<Radio />} label="Dev" />
                                                <FormControlLabel value="test" control={<Radio />} label="Test" />
                                                <FormControlLabel value="uat" control={<Radio />} label="UAT" />
                                                <FormControlLabel value="prod" control={<Radio />} label="Live" />
                                            </RadioGroup>
                                        </FormControl>
                                    </div> */}
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center justify-content-lg-start">
                <div className="button-container text-center text-lg-start">
                  <button
                    className="app-btn-primary"
                    onClick={handleSubmit}
                    disabled={!Password || !EmailExistOrNotRes?.status}
                  >
                    {t("Login")}
                  </button>
                  <div className="forgot-password-container">
                    <label>
                      {t("Forgot your password?Recover").slice(0, 21)}{" "}
                      <b onClick={handleShow}>
                        {t("Forgot your password?Recover").slice(21, 28)}
                      </b>
                    </label>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        className="password-recover-popup"
        style={{
          backgroundColor: "transparent",
          opacity: 0.9,
        }}
      >
        <Modal.Body>
          <div className="d-flex flex-column align-items-center justify-content-center">
            <img src={smaliIcon} alt="smali" width={35} height={35} />
            <div className="popup-title">{t("Forgot your password?")}</div>
            <div className="popup-description">
              {t("It could happen…").slice(0, 21)}
              <br />
              {t("Enter your email and we will send you an email") +
                " " +
                t("with a link to recover your account.")}
            </div>
            <div className="email-input-container">
              <input
                id="emailinput"
                value={emailsend}
                onChange={(e) => {
                  setEmailValid(false);
                  setEmailsend(e.target.value.toLowerCase().trim());
                  setMsgpop();
                }}
                autocomplete="off"
                placeholder={t("Your email")}
                className={!emailsend && error ? "email-input" : "email-input"}
                type="email"
              />
              {emailValid == true && emailsend != "" && (
                <div className="warning">
                  <i class="bi bi-exclamation-circle"></i>
                  &nbsp; Your email is invalid
                </div>
              )}
              {emailsend == "" && error == true && (
                <div className="warning ">Please fill in this field</div>
              )}
              {emailSenddata?.status && (
                <div className="warning text-success">
                  {msgpop && (
                    <div>
                      <i class="bi bi-exclamation-circle"></i>
                      &nbsp; {msgpop}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="action-footer">
              <button
                className="app-btn-secondary"
                onClick={() => {
                  setShow(false);
                  setEmailsend("");
                  window.location.reload();
                }}
              >
                {t("Cancel")}
              </button>
              <button className="app-btn-primary" onClick={sendEmail}>
                {t("Send")}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default memo(ServerLoginPage);
